import { render, staticRenderFns } from "./PaybillInstructions.vue?vue&type=template&id=5505380f"
import script from "./PaybillInstructions.vue?vue&type=script&setup=true&lang=js"
export * from "./PaybillInstructions.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports